import { Alert } from '@twilio-paste/core/alert';
import { Box } from '@twilio-paste/core/box';
import { Label } from '@twilio-paste/core/label';

import { AppSecrets } from '../../../../modules/Apps';

import { AppSecret } from './AppSecret';

type ReadOnlyAppSettingsDrawerProps = AppSecrets;

export function AppSecretsSection({
  apiPrimaryKey,
  apiSecondaryKey,
}: ReadOnlyAppSettingsDrawerProps) {
  return (
    <Box>
      <Box marginBottom="space60">
        <Box marginTop="space60">
          <Label>Primary Api Key</Label>
          <AppSecret apiKey={apiPrimaryKey} />
        </Box>

        <Box marginTop="space60">
          <Label>Secondary Api Key</Label>
          <AppSecret apiKey={apiSecondaryKey} />
        </Box>
      </Box>

      <Alert variant="warning">
        Please make sure to save these secrets securely, as they will not be displayed again!
      </Alert>
    </Box>
  );
}
